<template>
    <transition
        :mode="mode"
        name="def-fade"
        class="def-fade"
    >
        <slot />
    </transition>
</template>

<script>
export default {
    name: 'DefFade',
    props: ['mode'],
}
</script>

<style lang="scss" scoped>
.def-fade{
    &-enter-active,
    &-leave-active {
        transition: opacity .3s ease;
    }
    &-enter-from,
    &-leave-to
        /* .component-fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
}
</style>